import { defineMessages } from 'react-intl';

export default defineMessages({

    editUser: {
        id: "ri.admin.RI_UserEdit.title1.Edit User",
        defaultMessage: "Edit User"
    },
    addNewUser: {
        id: "ri.admin.RI_UserEdit.title1.Add New User",
        defaultMessage: "Add New User"
    },
    usrName: {
        id: 'ri.admin.RI_UserEdit1.Username',
        defaultMessage: 'Username'
    },
    firstName: {
        id: 'ri.admin.RI_UserEdit1.First Name',
        defaultMessage: 'First Name'
    },    
    lastName: {
        id: 'ri.admin.RI_UserEdit1.Last Name',
        defaultMessage: 'Last Name'
    },    
    email: {
        id: 'ri.admin.RI_UserEdit1.Email',
        defaultMessage: 'Email'
    },    
    cancelButton: {
        id: 'ri.admin.RI_UserEdit1.Cancel',
        defaultMessage: 'Cancel'
    },    
    saveButton: {
        id: 'ri.admin.RI_UserEdit1.Save',
        defaultMessage: 'Save'
    },    
    fieldEmpty: {
        id: 'ri.admin.RI_UserEdit1.Field Empty',
        defaultMessage: 'The field cannot be empty!'
    },
    successMessage: {
        id: 'ri.admin.RI_UserEdit1.Success Message',
        defaultMessage: 'The profile has been updated!'
    },   
    insuredName: {
        id: 'ri.admin.RI_UserEdit1.Insured Name',
        defaultMessage: 'Insured Name'
    },
    created: {
        id: "ri.admin.RI_UserEdit1.Created",
        defaultMessage: "Created"
    },
    userManager: {
        id: "ri.admin.RI_UserEdit1.User Manager",
        defaultMessage: "User Manager"
    },
    lastAccess: {
        id: "ri.admin.RI_UserEdit1.Last Access",
        defaultMessage: "Last Access"
    },
    Billing: {
        id: "ri.admin.RI_UserEdit1.Billing",
        defaultMessage: "Billing"
    },
    claim: {
        id: "ri.admin.RI_UserEdit1.Claims",
        defaultMessage: "Claims"
    },
    marketing: {
        id: "ri.admin.RI_UserEdit1.Marketing",
        defaultMessage: "Marketing"
    },
    producerNo: {
        id: "ri.admin.RI_UserEdit1.Producer Number",
        defaultMessage: "Producer Number"
    },
    webAccessCode: {
        id: "ri.admin.RI_UserEdit1.Web Access Code",
        defaultMessage: "Web Access Code"
    },
    invalidEmail: {
        id: 'ri.admin.RI_UserEdit1.Invalid Email',
        defaultMessage: 'Email address is invalid!'
    },
    invalidFirstName: {
        id: 'ri.admin.RI_UserEdit1.First Name1',
        defaultMessage: 'First Name is a required field!'
    },
    invalidLastName: {
        id: 'ri.admin.RI_UserEdit1.Last Name1',
        defaultMessage: 'Last Name is a required field!'
    },
    invalidUserName: {
        id: 'ri.admin.RI_UserEdit1.User Name is a required field',
        defaultMessage: 'User Name is a required field!'
    },
    userNameExist: {
        id: 'ri.admin.RI_UserEdit1.User Name already exist! Choose another one, please!',
        defaultMessage: 'User Name already exist! Choose another one, please!'
    },
    invalidWebAccessCode: {
        id: 'ri.admin.RI_UserEdit1.Web Access Code is a required field!',
        defaultMessage: 'Web Access Code is a required field!'
    },
    invalidWebAccessCode2: {
        id: 'ri.admin.RI_UserEdit1.Invalid Web Access code!',
        defaultMessage: 'Invalid Web Access code!'
    },
    invalidInsuredName: {
        id: 'ri.admin.RI_UserEdit1.Inusred Name is a required field',
        defaultMessage: 'Inusred Name is a required field!'
    },
    invalidProducerNo: {
        id: "ri.admin.RI_UserEdit1.Producer Number is a required field!",
        defaultMessage: "Producer Number is a required field!"
    },
    invalidProducerNo2: {
        id: "ri.admin.RI_UserEdit1.Invalid Producer Number!",
        defaultMessage: "Invalid Producer Number!"
    },
});
